import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateShippingMethod } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useUpdateShippingMethod = () => {
    const queryClient = useQueryClient();

    const { mutate: updateShippingMethodMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateShippingMethod(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Shipping method updated successfully");
            queryClient.invalidateQueries(["shipping-methods"]);
            queryClient.invalidateQueries(["shipping-method"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update shipping method");
        },
    });

    return { updateShippingMethodMutate, isUpdating };
};
